(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xykee-header"]) return;
  try {
    
  if (!window.xykeeNavigationDelegated) {
    window.xykeeNavigationDelegated = true;
    const desktop = window.matchMedia('(min-width: 1100px)');
    const targetElement = (event) => event.target instanceof Element ? event.target : null;
    const detailsFor = (item) => item.querySelector('[data-xyk-series-details]');

    const closeSeries = (item, restoreFocus = false) => {
      const details = detailsFor(item);
      if (!details) return;
      details.open = false;
      if (restoreFocus) {
        item.dataset.xykDismissed = 'true';
        details.querySelector('summary').focus();
      }
    };

    document.addEventListener('pointerover', (event) => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      const item = targetElement(event)?.closest('.xyk-nav [data-xyk-series]');
      if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) return;
      delete item.dataset.xykDismissed;
      detailsFor(item).open = true;
    });

    document.addEventListener('pointerout', (event) => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      const item = targetElement(event)?.closest('.xyk-nav [data-xyk-series]');
      if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) return;
      if (item.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
      closeSeries(item);
    });

    document.addEventListener('focusin', (event) => {
      if (!desktop.matches) return;
      const target = targetElement(event);
      if (!target?.matches(':focus-visible')) return;
      const item = target.closest('.xyk-nav [data-xyk-series]');
      if (item && !item.dataset.xykDismissed) detailsFor(item).open = true;
    });

    document.addEventListener('focusout', (event) => {
      const target = targetElement(event);
      const item = target?.closest('[data-xyk-series]');
      if (item && !(event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) {
        closeSeries(item);
        delete item.dataset.xykDismissed;
      }
      const mobileMenu = target?.closest('[data-xyk-mobile-menu]');
      if (mobileMenu && !(event.relatedTarget instanceof Node && mobileMenu.contains(event.relatedTarget))) {
        mobileMenu.open = false;
      }
    });

    document.addEventListener('pointerdown', (event) => {
      const target = targetElement(event);
      for (const item of document.querySelectorAll('[data-xyk-navigation] [data-xyk-series]')) {
        if (!item.contains(target)) closeSeries(item);
      }
      for (const mobileMenu of document.querySelectorAll('[data-xyk-mobile-menu][open]')) {
        if (!mobileMenu.contains(target)) mobileMenu.open = false;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const target = targetElement(event);
      const header = target?.closest('[data-xyk-navigation]');
      if (!header) return;
      const item = target.closest('[data-xyk-series]');
      if (item && detailsFor(item).open) {
        event.preventDefault();
        closeSeries(item, true);
        return;
      }
      const mobileMenu = header.querySelector('[data-xyk-mobile-menu][open]');
      if (mobileMenu) {
        event.preventDefault();
        mobileMenu.open = false;
        mobileMenu.querySelector('summary').focus();
      }
      for (const openItem of header.querySelectorAll('[data-xyk-series]')) closeSeries(openItem);
    });

    document.addEventListener('toggle', (event) => {
      const details = targetElement(event);
      if (!details?.matches('[data-xyk-series-details], [data-xyk-mobile-menu]')) return;
      details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
    }, true);

    desktop.addEventListener('change', () => {
      for (const header of document.querySelectorAll('[data-xyk-navigation]')) {
        const activeElement = document.activeElement;
        const hiddenNavigation = desktop.matches ? header.querySelector('[data-xyk-mobile-menu]') : header.querySelector('.xyk-nav');
        for (const details of header.querySelectorAll('details')) details.open = false;
        if (hiddenNavigation?.contains(activeElement)) {
          const nextFocus = desktop.matches ? header.querySelector('.xyk-nav a') : header.querySelector('[data-xyk-mobile-menu] > summary');
          nextFocus?.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
